var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#3CB4E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 18.9697L9 22.9997L13.0299 21.6997L10.3 18.9697Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5574 11.6927L11.2148 18.0352L13.9725 20.7928L20.315 14.4503L17.5574 11.6927Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8062 12.015L19.9862 10.195C19.7262 9.935 19.3362 9.935 19.0762 10.195L18.4912 10.78L21.2212 13.5099L21.8062 12.9249C22.0661 12.665 22.0661 12.275 21.8062 12.015Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImageIcon);
export default __webpack_public_path__ + "static/media/editImageIcon.236a1384565a87f7dc2ec154dbbd7efc.svg";
export { ForwardRef as ReactComponent };